var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOperationalForecastTerminal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#operational-forecast-terminal_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M5 0h14a5 5 0 0 1 5 5v14a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5a5 5 0 0 1 5-5M2 17.738h20.035v-1H2zm.36-7.966v5.935h1v-4.936l.931.932v4.004h1v-3.004l.929.929v2.075h1v-1.075l1.04 1.04v.014h.014l13.761.021v-2.606l-2.218-.005-3.612-3.779V8.202l-1 .95v.366a.5.5 0 0 0 .138.345l3.088 3.23-2.007-.004-4.338-4.486v-1.42l-1 1.019v.603a.5.5 0 0 0 .14.348l3.804 3.933-2.15-.004-4.865-5.037V5.861l-1.5 1.322v1.165a.75.75 0 0 0 .21.521l4.066 4.209-2.302-.005L4 8.583v-3.93L2 6.07v3.342z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "operational-forecast-terminal_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgOperationalForecastTerminal;